import { ZLabParams } from './z-lab.component';

export const Z_LAB_DEFAULT: ZLabParams = {
  initialMu: 170,
  initialSigma: 15,
  initialX: 185,
};

export const Z_LAB_STANDARD_NORMAL: ZLabParams = {
  initialMu: 0,
  initialSigma: 1,
  initialX: 1.5,
};

export const Z_LAB_NEGATIVE_Z: ZLabParams = {
  initialMu: 100,
  initialSigma: 15,
  initialX: 80,
};

export const Z_LAB_PRESETS: Record<string, Record<string, unknown>> = {
  default: { params: Z_LAB_DEFAULT },
  'standard-normal': { params: Z_LAB_STANDARD_NORMAL },
  'negative-z': { params: Z_LAB_NEGATIVE_Z },
};
